import React, { useState } from 'react';
import ReferralPartnerDashboard from './ReferralPartnerDashboard';
import Admissions from '../admin/Admissions';

const ReferralPartnerMain = ({ user }) => {
  const [currentView, setCurrentView] = useState('dashboard');
  const [selectedPartnerId, setSelectedPartnerId] = useState(null);

  const handleViewApplications = (partnerId) => {
    setSelectedPartnerId(partnerId);
    setCurrentView('applications');
  };

  const handleBackToDashboard = () => {
    setCurrentView('dashboard');
    setSelectedPartnerId(null);
  };

  return (
    <div>
      {currentView === 'dashboard' ? (
        <ReferralPartnerDashboard user={user} onViewApplications={handleViewApplications} />
      ) : (
        <div>
          <button
            onClick={handleBackToDashboard}
            style={{
              marginBottom: '1rem',
              padding: '0.5rem 1rem',
              backgroundColor: 'var(--primary)',
              color: 'white',
              border: 'none',
              borderRadius: '4px',
              cursor: 'pointer',
            }}
          >
            ← Back to Dashboard
          </button>
          <Admissions user={user} />
        </div>
      )}
    </div>
  );
};

export default ReferralPartnerMain;
